export const APP_NAME = ""
export const ACTIVE = <button className='rounded bg-green-500 border border-green-300 p-1 disabled'>ACTIVE</button>
export const INACTIVE = <button className='rounded bg-red-500 border border-red-300 p-1 disabled'>INACTIVE</button>

export const SUPERADMIN = "SUPERADMIN"
export const ADMIN = "ADMIN"
export const USER = "USER"